import React from "react";
import InputComponentV2 from "../../InputComponentV2";
import PhoneNumberInput from "../../PhoneNumberInput";
import DropDownComponentV2 from "../../DropDownComponentV2";
import DropDownComponentSortedV2 from "../../DropDownComponentSortedV2";
import TextFieldComponentV2 from "../../TextFieldComponentV2";

function GeneralInformationEmergencySection(props) {
  const {
    translate,
    emergencyContactFirstName,
    handleEmergencyContactFirstNameChange,
    emergencyContactLastName,
    handleEmergencyContactLastNameChange,
    emergencyContactRelationship,
    handleEmergencyContactRelationshipChange,
    emergencyRelationshipOther,
    handleEmergencyRelationshipOther,
    emergencyContactPhoneNumber,
    handleEmergencyContactPhoneNumberChange,
    emergencyContactEmail,
    handleEmergencyContactEmailChange,
    emergencyContactAddress,
    handleEmergencyContactAddressChange,
    emergencyContactCity,
    handleEmergencyContactCityChange,
    emergencyContactNationality,
    handleEmergencyContactNationalityChange,
    provinceEmergencyContact,
    handleProvinceEmergencyContactChange,
    emergencyContactCountry,
    handleEmergencyContactCountryChange,
    payerName,
    handlePayerNameChange,
    payerPhoneNumber,
    handlePayerPhoneNumberChange,
  } = props;

  return (
    <div style={{ width: "100%", marginLeft: "0px" }}>
      <div style={{ paddingBottom: "25px", borderTop: "1px solid red", paddingTop: "10px" }}>
        <span id="emergency-contact" style={{ fontSize: "18px", fontWeight: "600", color: "red" }}>{translate("EmergencyContact")}</span>
      </div>
      <div style={{ gap: "20px", display: "flex", flexDirection: "row" }}>
        <InputComponentV2 title={translate("EmergencyContactFirstName")} width="250px" value={emergencyContactFirstName} onChange={handleEmergencyContactFirstNameChange} />
        <InputComponentV2 title={translate("EmergencyContactLastName")} width="250px" value={emergencyContactLastName} onChange={handleEmergencyContactLastNameChange} />
        <DropDownComponentSortedV2 api="relationship" title={translate("Relationship")} width="250px" value={emergencyContactRelationship} onChange={handleEmergencyContactRelationshipChange} />
        {emergencyContactRelationship === "Other" ? <InputComponentV2 title={translate("IfOtherDescribe")} width="250px" value={emergencyRelationshipOther} onChange={handleEmergencyRelationshipOther} /> : ""}
        <PhoneNumberInput title={translate("ContactPhoneNumber")} value={emergencyContactPhoneNumber} onChange={handleEmergencyContactPhoneNumberChange} />
        <InputComponentV2 title={translate("ContactEmail")} width="250px" value={emergencyContactEmail} onChange={handleEmergencyContactEmailChange} />
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "row", marginTop: "20px" }}>
        <div style={{ width: "auto", gap: "20px", display: "flex", justifyContent: "flex-start" }}>
          <TextFieldComponentV2 title={translate("PhysicalAddressOfResidence")} value={emergencyContactAddress} onChange={handleEmergencyContactAddressChange} width="530px" />
        </div>
        <div style={{ width: "50%", display: "flex", flexDirection: "row" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginLeft: "20px", marginRight: "20px" }}>
            <InputComponentV2 title={translate("City")} width="250px" value={emergencyContactCity} onChange={handleEmergencyContactCityChange} />
            <DropDownComponentV2 api="nationalities" title={translate("Nationality")} value={emergencyContactNationality} onChange={handleEmergencyContactNationalityChange} width="250px" />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <div style={{ paddingLeft: "10px" }}>
              <InputComponentV2 title={translate("StateProvince")} width="250px" value={provinceEmergencyContact} onChange={handleProvinceEmergencyContactChange} />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <DropDownComponentSortedV2 api="countries" title={translate("Country")} value={emergencyContactCountry} onChange={handleEmergencyContactCountryChange} width="250px" />
            </div>
          </div>
        </div>
      </div>
      <div className="tab-form-container-fied" style={{ marginBottom: "130px", gap: "20px", display: "flex", flexDirection: "row", alignItems: "flex-end" }}>
        <InputComponentV2 title={translate("PersonPayingForTreatment")} width="250px" value={payerName} onChange={handlePayerNameChange} />
        <PhoneNumberInput title={translate("PhoneNumberOfPersonPaying")} value={payerPhoneNumber} onChange={handlePayerPhoneNumberChange} />
      </div>
    </div>
  );
}

export default GeneralInformationEmergencySection;
